// Custom JS
// Add this JavaScript to handle tab switching

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.detail-tab');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      
      const tabContents = document.querySelectorAll('.tab-detail-content');
      tabContents.forEach(tc => tc.style.display = 'none');
      
      const tabContentId = tab.getAttribute('data-tab-content');
      const activeContent = document.getElementById(tabContentId);
      activeContent.style.display = 'block';
    });
  });
});

$(document).ready(function() {

});

  function moreDetailsPage(element) {
    // Toggle visibility of tabs
    document.getElementById('nutritional-info-tab').style.display = 'none';
    document.getElementById('suggested-uses-tab').style.display = 'none';
    document.getElementById('more-details-tab').style.display = 'block';
    // Remove active class from all tabs
    document.querySelectorAll('.detail-tab').forEach(function(tab) {
        tab.classList.remove('active');
    });

    // Add active class to the more-details-tab
    document.querySelector('.detail-tab-3').classList.add('active');

    // Scroll to the "more-details-tab" section
    document.getElementById('more-details-tab').scrollIntoView({ behavior: 'smooth' });
  }


